// extracted by mini-css-extract-plugin
module.exports = {"card":"ManageDesignsCard_card__3s9n8","cardImageWrapper":"ManageDesignsCard_cardImageWrapper__1h7lV","title":"ManageDesignsCard_title__21jQi"};